// Context for the users selected route
import { createContext } from "react";
export const RouteContext = createContext("/");